(function(angular){
	'use strict';
	
	angular
		.module('updateSSNModule', [
			'coreModule',
			'formValidationModule',
			'ui.mask'
		])
		.value('globalConfig', globalConfig);

})(window.angular);